import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Bold,
  Header1,
  Header3,
  Page
} from "app/NativeComponents/common";
import { InlineButton, OnboardingWrapper } from "app/NativeComponents/snippets";

import {
  renderDate,
  displayIntercom,
  startRedirect,
  logout
} from "app/NativeActions";

class PausedAccount extends Component {
  componentDidMount() {
    if (this.props.device == "desktop") {
      this.props.startRedirect("/paused-account");
    }
  }

  render() {
    const { source_of_truth } = this.props;
    return (
      <Page
        metaTitle={"Paused Account - DealMachine for Real Estate"}
        responsive_design={true}
      >
        <OnboardingWrapper>
          <Wrapper style={{ padding: 25 }}>
            <Header1 style={{ textAlign: "center" }}>
              <Bold>We'll see you again, soon.</Bold>
            </Header1>
            {!!source_of_truth?.subscription?.pause_resumes_at ? (
              <Header3 style={{ textAlign: "center" }}>
                Your account is paused and will resume on{" "}
                {renderDate(
                  source_of_truth?.subscription?.pause_resumes_at,
                  true
                )}
              </Header3>
            ) : (
              <Header3 style={{ textAlign: "center" }}>
                Your account is paused.
              </Header3>
            )}
          </Wrapper>
          <Wrapper
            style={{
              width: "100%",
              margin: this.props.device == "desktop" ? "5px auto" : 0,
              alignSelf: "stretch"
            }}
          >
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "stretch"
              }}
            >
              <InlineButton
                button_type="full"
                id="intercom_button"
                onPress={() => {
                  displayIntercom();
                }}
              >
                Need help? Talk to a human.
              </InlineButton>
              <InlineButton
                button_type="full"
                onPress={() => this.props.logout()}
              >
                Logout
              </InlineButton>
            </Wrapper>
          </Wrapper>
        </OnboardingWrapper>
      </Page>
    );
  }
}

const mapStateToProps = ({ native, billing }) => {
  const { device } = native;
  const { source_of_truth } = billing;
  return { device, source_of_truth };
};

export default connect(mapStateToProps, {
  logout,
  startRedirect
})(PausedAccount);
